import { VitalsCardGrid } from './review/VitalCard';

export default function VitalsGrid({ note, onChange, flags, allowDelete = true }) {
  const mergedFlags = [...(note?.flags || []), ...(flags || [])];
  return (
    <VitalsCardGrid
      note={note}
      onChange={onChange}
      flags={mergedFlags}
      allowDelete={allowDelete}
    />
  );
}
